"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var producer_errors_1 = require("./producer-errors");
var HttpProducer = /** @class */ (function () {
    function HttpProducer(edgeEndpoint) {
        if (edgeEndpoint === void 0) { edgeEndpoint = HttpProducer.DEVELOPMENT_ENDPOINT; }
        this.edgeEndpoint = edgeEndpoint;
    }
    HttpProducer.prototype.produce = function (monorailEvent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var timeNow, eventPayload, edgeResponse, error_1, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        timeNow = Date.now().toString();
                        eventPayload = this.convertFieldsToUnderscoreCase(monorailEvent);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(this.edgeEndpoint, {
                                method: 'post',
                                headers: {
                                    'Content-Type': 'application/json; charset=utf-8',
                                    'X-Monorail-Edge-Event-Created-At-Ms': timeNow,
                                    'X-Monorail-Edge-Event-Sent-At-Ms': timeNow,
                                },
                                body: JSON.stringify({
                                    schema_id: monorailEvent.schemaId,
                                    payload: eventPayload,
                                }),
                            })];
                    case 2:
                        edgeResponse = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        throw new producer_errors_1.MonorailRequestError(error_1);
                    case 4:
                        if (!!edgeResponse.ok) return [3 /*break*/, 6];
                        _a = producer_errors_1.MonorailUnableToProduceError.bind;
                        _b = {
                            status: edgeResponse.status
                        };
                        return [4 /*yield*/, edgeResponse.text()];
                    case 5: throw new (_a.apply(producer_errors_1.MonorailUnableToProduceError, [void 0, (_b.message = _c.sent(),
                            _b)]))();
                    case 6: return [2 /*return*/, { status: edgeResponse.status }];
                }
            });
        });
    };
    HttpProducer.prototype.convertFieldsToUnderscoreCase = function (monorailEvent) {
        var temp = {};
        for (var _i = 0, _a = Object.keys(monorailEvent.payload); _i < _a.length; _i++) {
            var key = _a[_i];
            var payloadElement = monorailEvent.payload[key];
            temp[this.convertStringToUnderscoreCase(key)] = payloadElement;
        }
        return temp;
    };
    HttpProducer.prototype.convertStringToUnderscoreCase = function (camelCaseString) {
        return camelCaseString
            .split(/(?=[A-Z])/)
            .join('_')
            .toLowerCase();
    };
    HttpProducer.DEVELOPMENT_ENDPOINT = 'http://localhost:8082/v1/produce';
    HttpProducer.PRODUCTION_ENDPOINT = 'https://monorail-edge.shopifysvc.com/v1/produce';
    HttpProducer.PRODUCTION_CANADA_ENDPOINT = 'https://monorail-edge-ca.shopifycloud.com/v1/produce';
    return HttpProducer;
}());
exports.HttpProducer = HttpProducer;
